import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { IMaskInput } from 'react-imask';
import { dateInputToIso } from './reportFormat';
import type { ReportPeriod } from 'services/interfaces/storeGroupReport';

function toDisplayDate(date: Date): string {
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  return `${dd}-${mm}-${date.getFullYear()}`;
}

// dd-mm-yyyy -> yyyy-mm-dd; string vazia se incompleta ou data inexistente.
function displayToInput(value: string): string {
  const match = /^(\d{2})-(\d{2})-(\d{4})$/.exec(value);
  if (!match) return '';
  const [, dd, mm, yyyy] = match;
  const date = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
  if (date.getMonth() !== Number(mm) - 1 || date.getDate() !== Number(dd)) {
    return '';
  }
  return `${yyyy}-${mm}-${dd}`;
}

function defaultRange(): { startInput: string; endInput: string } {
  const end = new Date();
  const start = new Date();
  start.setDate(start.getDate() - 30);
  return { startInput: toDisplayDate(start), endInput: toDisplayDate(end) };
}

interface ReportPeriodFilterProps {
  onApply(period: ReportPeriod): void;
}

// Dois inputs com máscara dd-mm-aaaa (type="date" segue o locale do navegador).
// Aplica os últimos 30 dias assim que monta.
const ReportPeriodFilter: React.FC<ReportPeriodFilterProps> = ({ onApply }) => {
  const initial = defaultRange();
  const [startInput, setStartInput] = useState(initial.startInput);
  const [endInput, setEndInput] = useState(initial.endInput);

  useEffect(() => {
    onApply({
      start: dateInputToIso(displayToInput(initial.startInput)),
      end: dateInputToIso(displayToInput(initial.endInput), true),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- só na primeira carga
  }, []);

  const startIso = displayToInput(startInput);
  const endIso = displayToInput(endInput);

  const handleApply = () => {
    if (!startIso || !endIso) return;
    onApply({
      start: dateInputToIso(startIso),
      end: dateInputToIso(endIso, true),
    });
  };

  return (
    <HStack align="end" spacing={3} flexWrap="wrap">
      <FormControl w="auto">
        <FormLabel fontSize="sm">De</FormLabel>
        <Input
          as={IMaskInput}
          mask="00-00-0000"
          placeholder="dd-mm-aaaa"
          size="sm"
          value={startInput}
          onAccept={(value: string) => setStartInput(value)}
        />
      </FormControl>
      <FormControl w="auto">
        <FormLabel fontSize="sm">Até</FormLabel>
        <Input
          as={IMaskInput}
          mask="00-00-0000"
          placeholder="dd-mm-aaaa"
          size="sm"
          value={endInput}
          onAccept={(value: string) => setEndInput(value)}
        />
      </FormControl>
      <Button
        size="sm"
        colorScheme="yooga"
        onClick={handleApply}
        isDisabled={!startIso || !endIso}
      >
        Aplicar
      </Button>
    </HStack>
  );
};

export default ReportPeriodFilter;
